<template>
  <div
    class="video-play-page"
    :class="{
      'video-play-page__h5': isH5,
      'video-play-page__electron': isElectron,
      'portrait-mode': isH5PortraitMode,
      'cinema-mode': isCinemaMode,
    }"
  >
    <div
      class="video-play-content"
      :class="{
        'ai-mode-video-play-content': openAiMode,
      }"
    >
      <nav-bar
        class="video-play-nav-bar"
        :class="{ 'white-bg': changeNavBarBg }"
        v-if="!isH5 && !isElectron && !isCinemaMode"
      />
      <!-- Cinema Mode: 深色 Header -->
      <div
        v-if="isCinemaMode"
        class="cinema-header"
        :class="{ 'cinema-header--collapsed': isSidebarCollapsed }"
      >
        <div class="cinema-header__inner">
          <div class="cinema-header__left">
            <button
              class="cinema-back-btn"
              @click="$router.back()"
              title="返回课程主页"
            >
              <i class="el-icon-arrow-left"></i>
            </button>
            <div class="cinema-header__divider"></div>
            <h1 class="cinema-header__title">
              {{ lessonInfo.lesson_name || "" }}
            </h1>
          </div>
          <div class="cinema-header__right">
            <div class="cinema-header__actions">
              <button
                v-if="!isElectron"
                class="cinema-sidebar-toggle"
                :class="{ active: !isSidebarCollapsed }"
                @click="toggleSidebar"
              >
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
                  <line x1="9" y1="3" x2="9" y2="21" />
                </svg>
                <span>{{ isSidebarCollapsed ? "展开目录" : "目录" }}</span>
              </button>
              <div class="cinema-header__separator"></div>
              <CourseShare :productInfo="shareProductInfo" class="cinema-share-wrap" />
            </div>
          </div>
        </div>
      </div>
      <div class="content-wrap">
        <div
          class="left-cont-wrap"
          :class="{ 'player-fullscreen': isPlayerFullScreen, 'left-cont-wrap--audio': lessonInfo.lesson_type === 5 }"
        >
          <video-card
            ref="videoCard"
            :lessonInfo="lessonInfo"
            :courseInfo="courseInfo"
            :urlProgressTime="urlProgressTime"
            @changeAiMode="openAiModeChange"
            @saveNote="handleSaveNote"
            :openAiMode="openAiMode"
            @videoPlayerBoxHeight="handleVideoPlayerBoxHeight"
            @videoDurationChange="handleVideoDurationChange"
            @changeLesson="onChangeLesson"
            :noteComponentId="noteComponentId"
            @videoOrientation="onVideoOrientationDetected"
            :sidebarCollapsed="isCoursePanelCollapsed"
            @fullScreenChange="isPlayerFullScreen = $event"
            @quiz-active-change="onQuizActiveChange"
          />
          <!-- 切片列表 -->
          <video-slice-list
            v-if="openAiMode"
            :key="lessonId"
            @playCurNode="handlePlayCurNode"
            :courseId="courseId"
            :lessonId="Number(lessonId)"
            :videoDuration="aiSliceDuration"
            :courseCoverUrl="courseInfo.cover_url"
          />
        </div>
        <tabs
          ref="h5Tabs"
          v-if="isH5"
          class="tabs-box"
          :tabs-data="tabsData"
          @change="changeTab"
        />
        <right-operation-cont
          v-if="openAiMode"
          :videoPlayerBoxHeight="videoPlayerBoxHeight"
          :lesson-info="lessonInfo"
          :course-info="courseInfo"
          :activeTab="activeTab"
          @changeLesson="onChangeLesson"
          :havePrivateLesson="courseInfo.havePrivateLesson || 0"
          @playCurNode="handlePlayCurNode"
        />
        <course-card
          :noteComponentId="noteComponentId"
          v-else
          :lesson-info="lessonInfo"
          :course-info="courseInfo"
          :activeTab="activeTab"
          @changeLesson="onChangeLesson"
          :havePrivateLesson="courseInfo.havePrivateLesson || 0"
          :collapsed="isCoursePanelCollapsed"
          @toggleSidebar="toggleSidebar"
          :showSidebarToggle="!isElectron"
          :notesPlaceholder="
            isCinemaMode
              ? '在这里记录你的学习心得、重点难点...'
              : '请填写您的笔记'
          "
        />
        <!-- 侧栏收起时的浮动展开按钮 -->
        <div
          v-if="isSidebarCollapsed && !isH5 && !isCinemaMode && !isElectron"
          class="sidebar-expand-btn"
          @click="toggleSidebar"
        >
          <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
            <line x1="9" y1="3" x2="9" y2="21" />
          </svg>
          <span>展开目录</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapActions, mapState } from "vuex";
import usePortraitVideo from "./mixins/usePortraitVideo";
import RightOperationCont from "./ai-mode/RightOperationCont.vue";
import VideoSliceList from "./ai-mode/VideoSliceList.vue";
import { NavBar, CourseShare } from "@saas/components/src";
import { getCourseInfo } from "@saas/service-api/src/product-details";
import CourseCard from "./components/CourseCard.vue";
import VideoCard from "./components/VideoCard.vue";
import Tabs from "./components/Tabs.vue";
import {
  isH5,
  isHXApp,
  isMobile,
  getLessonIdFromReplayWinUrl,
} from "@saas/components/src/utils/utils";
import { replaceVideoLessonRoute } from "../utils/navigation-error";
import { onThemeChange } from "@saas/components/src/composables/useTheme";
import { EventBus } from "@saas/components/src/utils/event-bus";
export default {
  name: "VideoPlay",
  mixins: [usePortraitVideo],
  props: {},
  provide() {
    return {
      registerComponent: this.registerComponent,
      unregisterComponent: this.unregisterComponent,
    };
  },
  data() {
    return {
      openAiMode: false,
      changeNavBarBg: false,
      activeId: 1,
      courseId: null,
      lessonId: null,
      unitId: null,
      lessonInfo: {},
      courseInfo: {},
      isH5: isH5(),
      isElectron: window.isElectron,
      tabsData: [
        {
          title: "简介",
          isActive: false,
          type: "desc",
        },
        {
          title: "目录",
          isActive: true,
          type: "folder",
        },
      ],
      activeTab: "folder",
      videoPlayerBoxHeight: 0,
      videoPlayerDuration: 0,
      noteComponentId: "video-play-note",
      registeredComponents: new Set(),
      isSidebarCollapsed: false,
      isPlayerFullScreen: false,
      // 互动题显示时，目录和全屏课时列表都经由 onChangeLesson 统一拦截。
      quizActive: false,
    };
  },
  mounted() {
    this._prevAppBg = document.getElementById("app")?.style.background || "";
    this.updateAppBackground();
    this._unsubVideoTheme = onThemeChange(this.updateAppBackground);

    const { courseId = 0, unitId = 0, lessonId = 0 } = this.$route.params;
    const lsIds = JSON.parse(localStorage.getItem("video_play_ids") || "{}");
    if (lsIds.courseId && lsIds.unitId && lsIds.lessonId) {
      this.lessonId = lsIds.lessonId;
      this.unitId = lsIds.unitId;
      this.courseId = lsIds.courseId;
    } else {
      this.courseId = courseId;
      this.unitId = unitId;
      this.lessonId = lessonId;
    }
    //处理带有time播放位置参数的情况
    if (this.$route?.query?.time) {
      this.setUrlProgressTime(Number(this.$route.query.time));
    }
    // this.getLessonDetail();
    this.getCourseInfo();
    // 获取切片列表：判断是否可开启ai模式
    this.apiGetLessonOutline({ lesson_id: Number(this.lessonId) });

    // 平板/窄屏桌面默认收起右侧栏；H5 使用 tab 内容区，不参与侧栏收起状态
    if (!this.isH5 && window.innerWidth <= 1024) {
      this.isSidebarCollapsed = true;
    }
    // 监听滚动
    window.addEventListener("scroll", this.handleScroll, true);
    window.addEventListener("keydown", this.handleKeydown, false);
    if (window.isElectron) {
      window.ipcRenderer.on("refresh-login-win", this.refreshPage);
      window.ipcRenderer.on("replay-win-close", this.handleReplayWinClose);
    }
  },
  beforeDestroy() {
    // 恢复 #app 背景
    const appEl = document.getElementById('app');
    if (appEl) {
      appEl.style.background = this._prevAppBg || '';
    }
    if (this._unsubVideoTheme) {
      this._unsubVideoTheme();
    }

    // 移除监听
    window.removeEventListener("scroll", this.handleScroll, true);
    window.removeEventListener("keydown", this.handleKeydown, false);
    if (window.isElectron) {
      window?.ipcRenderer?.removeListener(
        "refresh-login-win",
        this.refreshPage
      );
      window.ipcRenderer.removeListener(
        "replay-win-close",
        this.handleReplayWinClose
      );
      localStorage.removeItem("video_play_ids");
    }
  },
  beforeRouteLeave(to, from, next) {
    const noteComp = this.findComponent("Notes");
    if (noteComp) {
      noteComp.checkLeaveStatus(next);
    } else {
      next();
    }
  },
  methods: {
    ...mapMutations("replay", [
      "setInitNoteContent",
      "apiGetLessonOutline",
      "setUrlProgressTime",
    ]),
    ...mapActions("replay", ["apiGetLessonOutline"]),
    updateAppBackground() {
      const appEl = document.getElementById("app");
      if (!appEl) {
        return;
      }
      const isDark = document.documentElement.classList.contains("dark");
      appEl.style.background = isDark
        ? "var(--mg-bg-page)"
        : "linear-gradient(180deg, #e3f8eb 0%, #e3f8eb 100%)";
    },
    handleReplayWinClose(event, params) {
      console.log(params, "handleReplayWinClose======");
      if (!params?.url) {
        return;
      }
      const lessonId = getLessonIdFromReplayWinUrl(params.url);
      console.log(lessonId, "handleReplayWinClose--lessonId======");
      if (Number(lessonId) === Number(this.lessonId)) {
        console.log("emit-video-play-note-update", {
          lessonId: this.lessonId,
        });

        EventBus.$emit("video-play-note-update", {
          lessonId: this.lessonId,
        });
      }
    },
    // 保存笔记
    handleSaveNote() {
      const noteComp = this.findComponent("Notes");
      if (noteComp) {
        noteComp.onClickSave(false);
      }
    },
    handleVideoPlayerBoxHeight(height) {
      this.videoPlayerBoxHeight = height;
    },
    handleVideoDurationChange(duration) {
      this.videoPlayerDuration = Number(duration) || 0;
    },
    openAiModeChange() {
      this.setInitNoteContent();
      if (!window.isElectron) {
        // 隐藏footer：防止切片展开时高度变化，底部footer会跳动
        let footerEl = document.querySelector("footer.footer");
        if (footerEl) {
          if (!this.openAiMode) {
            footerEl.style.display = "none";
          } else {
            footerEl.style.display = "block";
          }
        }
      }
      this.openAiMode = !this.openAiMode;
      this.handleSaveNote();
    },
    handlePlayCurNode(duration) {
      if (this.$refs.videoCard) {
        this.$refs.videoCard.playToDuration(duration);
      }
    },
    refreshPage() {
      console.log("refresh-login-win======");
      setTimeout(() => {
        window.location.reload();
      }, 2500);
    },
    // 监听键盘
    handleKeydown(e) {
      if (e.key === " ") {
        e.preventDefault();
      }
    },
    // 获取课程详情数据
    getCourseInfo() {
      getCourseInfo({
        course_id: this.courseId,
      }).then((res) => {
        if (res.code === 1) {
          this.courseInfo = res.data || {};
          this.havePrivateLesson();
          const unitList = res.data.unit_list || [];
          const lessonList = [];
          unitList.forEach((item) => {
            if (item?.lesson_list?.length) {
              lessonList.push(...item.lesson_list);
            }
            // if (+item.id === +this.unitId) {
            //   const lessonInfo = (item.lesson_list || []).find(lesson => +lesson.id === +this.lessonId)
            //   if (lessonInfo) {
            //     this.lessonInfo = JSON.parse(JSON.stringify(lessonInfo));
            //   }
            // }
          });
          const lessonInfo = lessonList.find(
            (lesson) => +lesson.id === +this.lessonId
          );
          if (lessonInfo) {
            this.lessonInfo = lessonInfo;
            this.unitId = this.lessonInfo.unit_id;
          } else if (this.courseInfo.havePrivateLesson) {
            // 有私教课
            const privateUnitList = res.data.private_unit_list;
            const privateLessonList = [];
            privateUnitList.forEach((item) => {
              privateLessonList.push(...item.lesson_list);
            });
            const privateLessonInfo = privateLessonList.find(
              (lesson) => +lesson.id === +this.lessonId
            );
            console.log(privateLessonInfo.id, "privateLessonInfo======1111");
            if (privateLessonInfo) {
              if (this.isH5) {
                this.activeTab = "private";
                let index = 0;
                this.tabsData.forEach((tab, i) => {
                  if (tab.type === this.activeTab) {
                    index = i;
                    tab.isActive = true;
                  } else {
                    tab.isActive = false;
                  }
                });
                setTimeout(() => {
                  this.$refs["h5Tabs"].updateIndicatorPosition(index);
                }, 500);
              }
              this.lessonInfo = privateLessonInfo;
              this.lessonInfo.isPrivate = true;
              this.unitId = this.lessonInfo.unit_id;
            } else {
              this.lessonInfo = lessonList[0] || {};
              this.unitId = this.lessonInfo.unit_id;
            }
          } else {
            this.lessonInfo = lessonList[0] || {};
            this.unitId = this.lessonInfo.unit_id;
          }
          this.applyLessonSidebarDefault();
        } else if (res.code === 6666) {
          this.$showErrorPage({
            tips: "课程不存在",
          });
        } else {
          this.$showErrorPage();
        }
      });
    },
    // 获取课时详情数据
    // getLessonDetail() {
    //   getLessonDetail({
    //     course_id: this.courseId,
    //     lesson_id: this.lessonId,
    //   }).then((res) => {
    //     if (res.code === 1) {
    //       this.lessonInfo = res.data || {};
    //     } else if (res.code === 40000) {
    //       // 未报名或者不在课程有效期内
    //       this.$message.error(res.message);
    //       // setTimeout(() => {
    //       //   this.$router.push({ name: "myCourse" });
    //       // }, 1500);
    //     } else if (res.code === 40007) {
    //       // 开启网页防火墙
    //       this.$router.replace("/firewall/" + this.courseId);
    //     } else {
    //       this.$message.error(res?.message || "请求失败");
    //     }
    //   });
    // },
    handleMouseEnter(id) {
      this.activeId = id;
      let elImageWrap = document.querySelector(".img-wrap");
      if (elImageWrap) {
        elImageWrap.scrollTop = 541 * (id - 1);
      }
    },
    handleScroll() {
      let scrollTop = document.documentElement?.scrollTop || 0;
      let height = document.querySelector(".nav-bar")?.offsetHeight || 0;
      if (scrollTop > height) {
        this.changeNavBarBg = true;
      } else {
        this.changeNavBarBg = false;
      }
    },
    onChangeLesson(lesson) {
      if (this.quizActive) {
        this.$message.warning("请完成当前互动题后再切换课时");
        return;
      }
      this.setUrlProgressTime(null);
      this.videoPlayerDuration = 0;
      this.lessonId = lesson.id;
      this.lessonInfo = lesson;
      if (!window.isElectron) {
        replaceVideoLessonRoute(this.$router, {
          courseId: this.courseId,
          unitId: this.unitId,
          lessonId: this.lessonId,
        });
      } else {
        localStorage.setItem(
          "video_play_ids",
          JSON.stringify({
            lessonId: this.lessonId,
            unitId: this.unitId,
            courseId: this.courseId,
          })
        );
      }
      // 获取切片列表：判断是否可开启ai模式
      this.apiGetLessonOutline({ lesson_id: this.lessonInfo.id });
      this.applyLessonSidebarDefault();
    },
    onQuizActiveChange(active) {
      this.quizActive = !!active;
    },
    applyLessonSidebarDefault() {
      if (this.isH5) {
        this.isSidebarCollapsed = false;
        return;
      }
      if (this.lessonInfo?.lesson_type === 5 && window.innerWidth <= 1024) {
        this.isSidebarCollapsed = false;
      }
    },
    toggleSidebar() {
      this.isSidebarCollapsed = !this.isSidebarCollapsed;
    },
    changeTab(tab) {
      this.activeTab = tab.type;
    },
    havePrivateLesson() {
      let length = this.courseInfo?.private_unit_list?.length;
      let data = this.tabsData.find((tab) => {
        return tab.type === "private";
      });
      if (!data && length) {
        this.tabsData.push({
          title: "私教课",
          isActive: false,
          type: "private",
        });
      }
      this.courseInfo.havePrivateLesson = length;
    },
    registerComponent(component) {
      this.registeredComponents.add(component);
    },
    unregisterComponent(component) {
      this.registeredComponents.delete(component);
    },
    findComponent(componentName) {
      for (const component of this.registeredComponents) {
        if (component.$options.name === componentName) {
          return component;
        }
      }
      return null;
    },
  },
  computed: {
    ...mapState("replay", ["urlProgressTime"]),
    isCoursePanelCollapsed() {
      return !this.isH5 && this.isSidebarCollapsed;
    },
    isCinemaMode() {
      return !this.isH5 && !this.isElectron && !this.openAiMode;
    },
    shareProductInfo() {
      return {
        id: this.courseInfo.id || this.$route.params.courseId,
        course_name: this.courseInfo.course_name || '',
        cover_url: this.courseInfo.cover_url || '',
      };
    },
    aiSliceDuration() {
      const playerDuration = Number(this.videoPlayerDuration) || 0;
      if (playerDuration > 0) {
        return playerDuration;
      }
      return Number(this.lessonInfo.duration) || 0;
    },
  },
  components: {
    "nav-bar": NavBar,
    CourseShare,
    CourseCard,
    VideoCard,
    Tabs,
    VideoSliceList,
    RightOperationCont,
  },
};
</script>

<style scoped lang="scss">
.video-play-page {
  min-width: 1200px;
  width: 100%;
  html.dark & {
    background: var(--mg-bg-page);

    .video-play-content {
      background: var(--mg-bg-page);
    }
  }
  .video-play-content {
    &.ai-mode-video-play-content {
      min-height: 100vh;
    }
    min-height: calc(100vh - 234px);
    background: url("../../assets/images/video-play/bg.png");
    background-position: top center;
    background-size: 100% auto;
    background-repeat: no-repeat;
    display: flex;
    .content-wrap {
      position: relative;
      flex: 1;
      display: flex;
      flex-direction: row;
      padding: 40px 100px 54px;
      margin-top: 70px;
    }
  }
  ::v-deep .video-play-nav-bar {
    .nav-bar {
      background: rgba($color: #fff, $alpha: 0.4);
      z-index: 1999;
      padding: 0 100px;
      .menu-row {
        width: unset;
      }
    }
  }
  ::v-deep .white-bg.video-play-nav-bar {
    .nav-bar {
      background: #fff;
    }
  }
  .left-cont-wrap {
    flex: 1;
    width: 0;
  }
  &:not(.cinema-mode):not(.video-play-page__h5) {
    .left-cont-wrap--audio {
      ::v-deep .video-player-box--audio {
        height: auto;
        aspect-ratio: 16 / 9;
      }

      ::v-deep .video-player-wrap {
        height: 100%;
      }

      ::v-deep .audio-player {
        height: 100%;
      }

      ::v-deep .audio-cover-wrap {
        flex: 1 1 0;
        aspect-ratio: auto;
      }

      ::v-deep .audio-player-loading {
        height: 100%;
        min-height: 0;
        aspect-ratio: auto;
      }
    }
  }
  // Phase 5: Cinema Mode（PC 端全屏深色布局）
  &.cinema-mode {
    background: #000;
    min-width: unset;
    width: 100%;
    height: 100vh;
    overflow: hidden;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 100;

    .video-play-content {
      min-height: unset;
      height: 100%;
      background: #000;
      display: flex;
      flex-direction: column;

      .content-wrap {
        padding: 16px;
        margin-top: 0;
        gap: 16px;
        flex: 1;
        min-height: 0;
        max-width: 1800px;
        margin-left: auto;
        margin-right: auto;
        width: 100%;
        background: #000;
      }
    }

    .left-cont-wrap {
      border-radius: 16px;
      overflow: hidden;
      box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1),
        0 8px 10px -6px rgba(0, 0, 0, 0.1);
      border: 1px solid rgba(30, 41, 59, 0.8);
      transition: border-radius 0.3s ease, box-shadow 0.3s ease;
      display: flex;
      flex-direction: column;
      background: #000;

      &.player-fullscreen {
        border-radius: 0;
        box-shadow: none;
      }
    }

    ::v-deep .top-gradient-overlay {
      display: none;
    }

    ::v-deep .video-area {
      height: 100% !important;
      position: relative;
    }

    ::v-deep .video-title {
      display: flex;
      position: absolute;
      top: 18px;
      left: 18px;
      right: auto;
      width: auto;
      height: 32px;
      line-height: 32px;
      padding: 0;
      background: transparent;
      border: 0;
      z-index: 30;

      .name {
        display: none;
      }
    }

    ::v-deep .ai-watch-video-btn {
      display: flex;
      margin-right: 0;
      height: 32px;
      background: var(--video-card-title-action-bg);
      border-color: var(--video-card-title-action-border);
      color: var(--video-card-title-action-text);
      box-shadow: 0 10px 24px rgba(15, 23, 42, 0.22);
    }

    ::v-deep .video-player-box {
      height: 100% !important;
      border-radius: 0;
    }

    .left-cont-wrap--audio {
      min-height: 0;

      ::v-deep .video-area {
        height: 100% !important;
        min-height: 0;
      }

      ::v-deep .video-player-box--audio {
        height: 100% !important;
        min-height: 0;
      }

      ::v-deep .video-player-wrap {
        height: 100% !important;
        min-height: 0;
      }

      ::v-deep .audio-player {
        height: 100% !important;
      }

      ::v-deep .audio-cover-wrap {
        flex: 1 1 0;
        aspect-ratio: auto;
      }
    }

    ::v-deep .course-info-area {
      width: 400px;
      min-width: 320px;
      margin: 0 !important;
      background: #1E293B !important;
      border: 1px solid var(--mg-border-subtle) !important;
      // box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.3),
      //   0 8px 10px -6px rgba(0, 0, 0, 0.2) !important;
      border-radius: 16px !important;
      overflow: hidden;
      height: auto;
      align-self: stretch;
      transition: width 0.3s ease-in-out, opacity 0.3s ease-in-out,
        min-width 0.3s ease-in-out;

      .org-name {
        display: none !important;
      }

      .course-wrap {
        background-color: transparent !important;
        border-color: transparent !important;
        border-radius: 0;
        box-shadow: none !important;
        margin-top: 0;
        flex: 1;
        min-height: 0;
        display: flex;
        flex-direction: column;

        // 隐藏课程封面/价格区域
        .course-info {
          display: none !important;
        }

        // Tab 暗色适配
        .tab-list {
          padding: 20px 20px 12px 20px;
          border-bottom: 1px solid rgba(148, 163, 184, 0.12);
          li {
            color: #94A3B8 !important;
            font-size: 16px !important;
            font-weight: 700 !important;
            &.active {
              color: #F1F5F9 !important;
              &::after {
                width: 16px;
                height: 4px;
                background: #00c89d;
                border-radius: 2px;
                bottom: -4px;
              }
            }
          }
          .sidebar-toggle {
            display: none !important;
          }
        }

        // Tab 下方内容区（外壳已是白色卡片）
        .tab-content-enter {
          background: transparent;
          border-radius: 0;
          border: none;
          box-shadow: none;
          overflow-y: auto;
          flex: 1;
          min-height: 0;

          // S3: 自定义滚动条
          &::-webkit-scrollbar {
            width: 5px;
          }
          &::-webkit-scrollbar-track {
            background: transparent;
          }
          &::-webkit-scrollbar-thumb {
            background: rgba(148, 163, 184, 0.2);
            border-radius: 3px;
          }

          // S4: Tab 切换 fadeSlideIn 动画
          animation: fadeSlideIn 0.25s cubic-bezier(0.2, 0.8, 0.2, 1);

          // 去掉 LessonList 组件内的固定高度限制，由外层统一管理滚动
          .lesson-list {
            max-height: none !important;
            overflow: visible !important;
          }

          // D: 课时列表暗色适配
          // 圆圈暗色适配（保留显示）
          .status-icon {
            border-color: #94A3B8 !important;
            color: #94A3B8 !important;
          }
          .status-not_started {
            border-color: var(--mg-control-hover-bg) !important;
            &:hover {
              border-color: #475569 !important;
            }
          }
          .status-locked {
            background: rgba(148, 163, 184, 0.3) !important;
          }
          // 隐藏竖线连接线
          .lesson-item::before {
            display: none !important;
          }
          // 课时列表布局
          .lesson-item {
            background-color: transparent !important;
            border-radius: 12px !important;
            border: none !important;
            padding-left: 12px !important;
            margin-bottom: 8px !important;
            .lesson-info .name {
              color: #F1F5F9 !important;
            }
            .lesson-info .other .teacher,
            .lesson-info .other .meta-row,
            .lesson-info .other .lesson-time {
              color: #94A3B8 !important;
            }
            &:hover {
              background-color: rgba(30, 41, 59, 0.5) !important;
            }
          }
          // 激活课时绿色高亮
          .active-lesson-item {
            position: relative !important;
            background-color: rgba(16, 185, 129, 0.1) !important;
            border: 1px solid rgba(16, 185, 129, 0.2) !important;
            border-left: none !important;
            overflow: visible !important;
            .lesson-info .name {
              color: #34D399 !important;
            }
            &::after {
              content: '' !important;
              position: absolute !important;
              left: 0 !important;
              top: 50% !important;
              transform: translateY(-50%) !important;
              width: 4px !important;
              height: 32px !important;
              background-color: #10B981 !important;
              border-radius: 0 4px 4px 0 !important;
            }
          }
          // 课时类型标签暗色适配
          .lesson-type-tag {
            color: #94A3B8 !important;
            border-color: rgba(148, 163, 184, 0.3) !important;
            &.tag-video {
              color: #94A3B8 !important;
              background-color: #1E293B !important;
              border-color: var(--mg-control-hover-bg) !important;
            }
            &.tag-audio {
              color: #E879F9 !important;
              background-color: rgba(74, 4, 78, 0.3) !important;
              border-color: rgba(74, 4, 78, 0.5) !important;
            }
            &.tag-live {
              color: #60A5FA !important;
              background-color: rgba(23, 37, 84, 0.2) !important;
              border-color: rgba(23, 37, 84, 0.3) !important;
            }
            &.tag-live-streaming {
              color: #34D399 !important;
              background-color: rgba(16, 185, 129, 0.1) !important;
              border-color: rgba(16, 185, 129, 0.2) !important;
            }
          }
        }

        // 章节列表 cinema-mode 适配
        .el-collapse-item {
          margin-bottom: 0 !important;
          &:last-child {
            margin-bottom: 0 !important;
          }
        }

        .el-collapse-item__header {
          background: rgba(15, 23, 42, 0.6) !important;
          border-radius: 0 !important;
          border-bottom: 1px solid rgba(148, 163, 184, 0.12) !important;
          color: #F1F5F9 !important;
          font-weight: 900 !important;
          -webkit-text-stroke: 0.3px currentColor;

          .unit-name .name-text {
            font-weight: 900 !important;
            color: #F1F5F9 !important;
            -webkit-text-stroke: 0.3px currentColor;
          }

          .unit-arrow {
            background: transparent !important;
            border-radius: 0 !important;
            color: #94A3B8 !important;
          }
        }

        // 笔记区域 cinema-mode 暗色适配
        .notes-container {
          --cinema-notes-text-primary: #f1f5f9;
          --cinema-notes-text-secondary: #cbd5e1;
          --cinema-notes-text-muted: #94a3b8;
          --cinema-notes-border: rgba(148, 163, 184, 0.18);
          --cinema-notes-editor-placeholder: #64748b;
          --cinema-notes-toolbar-icon: #cbd5e1;
          --cinema-notes-toolbar-icon-hover: #f8fafc;
          --cinema-notes-toolbar-icon-active-bg: rgba(148, 163, 184, 0.18);
          --cinema-notes-toolbar-bg: rgba(15, 23, 42, 0.78);
          --cinema-notes-toolbar-hover-bg: rgba(148, 163, 184, 0.14);
          --cinema-notes-disabled-bg: rgba(148, 163, 184, 0.24);
          --cinema-notes-disabled-text: #94a3b8;
          --cinema-notes-primary-action-bg: #e2e8f0;
          --cinema-notes-primary-action-hover-bg: #f8fafc;
          --cinema-notes-primary-action-text: #334155;
          --notes-text-primary: var(--cinema-notes-text-primary);
          --notes-text-secondary: var(--cinema-notes-text-secondary);
          --notes-text-muted: var(--cinema-notes-text-muted);
          --notes-border: var(--cinema-notes-border);
          --notes-editor-placeholder: var(--cinema-notes-editor-placeholder);
          --notes-toolbar-icon: var(--cinema-notes-toolbar-icon);
          --notes-toolbar-icon-hover: var(--cinema-notes-toolbar-icon-hover);
          --notes-toolbar-icon-active-bg: var(--cinema-notes-toolbar-icon-active-bg);
          --notes-toolbar-icon-filter: invert(0.82) brightness(1.18);
          --notes-toolbar-icon-hover-filter: invert(1) brightness(1.2);
          --notes-toolbar-bg: var(--cinema-notes-toolbar-bg);
          --notes-toolbar-hover-bg: var(--cinema-notes-toolbar-hover-bg);
          --notes-disabled-bg: var(--cinema-notes-disabled-bg);
          --notes-disabled-text: var(--cinema-notes-disabled-text);
          --notes-primary-action-bg: var(--cinema-notes-primary-action-bg);
          --notes-primary-action-hover-bg: var(--cinema-notes-primary-action-hover-bg);
          --notes-primary-action-text: var(--cinema-notes-primary-action-text);
          --wang-editor-mark-block-bg: #0f172a;
          --wang-editor-mark-block-border: rgba(148, 163, 184, 0.28);
          --wang-editor-mark-chip-bg: rgba(15, 23, 42, 0.82);
          --wang-editor-mark-block-text: #f1f5f9;
          --wang-editor-mark-block-muted-text: #94a3b8;

          .content-container {
            background: #0F172A !important;
          }

          .header {
            border-bottom-color: rgba(148, 163, 184, 0.12) !important;
          }

          .header .lesson-name {
            font-size: 20px !important;
            font-weight: 700 !important;
            color: #F1F5F9 !important;
            width: auto !important;
            flex: 1 !important;
            min-width: 0 !important;
            white-space: nowrap !important;
            overflow: hidden !important;
            text-overflow: ellipsis !important;
            -webkit-text-stroke: 0.3px currentColor;
          }

          // F: 保存提示暗色
          .handle-tip p {
            color: #94A3B8 !important;
          }

          // 编辑器内容区暗色适配
          .w-e-text-container {
            background: transparent !important;

            [contenteditable] {
              color: #F1F5F9 !important;
              caret-color: #F1F5F9 !important;
              // 纸张纹理（暗色版）
              background-image: linear-gradient(
                transparent 27px,
                rgba(255, 255, 255, 0.04) 28px
              ) !important;
              background-size: 100% 28px !important;
            }
          }

          .w-e-text-placeholder {
            color: var(--mg-text-muted) !important;
          }

          .comp-container__editor-toolbar {
            border-bottom-color: rgba(148, 163, 184, 0.18) !important;
          }

          markblock {
            color: var(--wang-editor-mark-block-text) !important;

            .qa-time,
            .qa-title {
              color: inherit !important;
              background: var(--wang-editor-mark-chip-bg) !important;
              border-color: var(--wang-editor-mark-block-border) !important;
            }

            .qa-time {
              color: var(--wang-editor-mark-block-muted-text) !important;

              img {
                filter: var(--notes-toolbar-icon-filter);
              }

              &:hover {
                color: var(--notes-toolbar-icon-hover) !important;
                background: var(--notes-toolbar-hover-bg) !important;
                border-color: var(--wang-editor-mark-block-border) !important;
              }

              &:hover::after {
                background-color: var(--wang-editor-mark-chip-bg) !important;
                filter: var(--notes-toolbar-icon-hover-filter);
              }
            }
          }

          .w-e-toolbar {
            .w-e-bar-item button {
              color: var(--notes-toolbar-icon) !important;

              svg {
                fill: var(--notes-toolbar-icon) !important;
                stroke: var(--notes-toolbar-icon) !important;
              }

              &:hover,
              &.active {
                color: var(--notes-toolbar-icon-hover) !important;

                svg {
                  fill: var(--notes-toolbar-icon-hover) !important;
                  stroke: var(--notes-toolbar-icon-hover) !important;
                }
              }
            }
          }

          .handle-box {
            background: rgba(15, 23, 42, 0.78) !important;

            .btn:not(.save-btn):not(.disabled) {
              color: var(--notes-toolbar-icon) !important;

              &:hover {
                color: var(--notes-toolbar-icon-hover) !important;
                background: var(--notes-toolbar-hover-bg) !important;
              }
            }

            .save-btn:not(.disabled) {
              color: var(--notes-primary-action-text) !important;
              background: var(--notes-primary-action-bg) !important;

              &:hover {
                background: var(--notes-primary-action-hover-bg) !important;
              }
            }

            .btn.disabled,
            .save-btn.disabled {
              color: var(--notes-disabled-text) !important;
              background: var(--notes-disabled-bg) !important;
            }
          }
        }
      }
    }

    // 影院模式下笔记区实际挂在播放器右侧，不经过 course-info-area。
    ::v-deep .notes-container {
      --cinema-notes-text-primary: #f1f5f9;
      --cinema-notes-text-secondary: #cbd5e1;
      --cinema-notes-text-muted: #94a3b8;
      --cinema-notes-border: rgba(148, 163, 184, 0.18);
      --cinema-notes-editor-placeholder: #64748b;
      --cinema-notes-toolbar-icon: #cbd5e1;
      --cinema-notes-toolbar-icon-hover: #f8fafc;
      --cinema-notes-toolbar-icon-active-bg: rgba(148, 163, 184, 0.18);
      --cinema-notes-toolbar-bg: rgba(15, 23, 42, 0.78);
      --cinema-notes-toolbar-hover-bg: rgba(148, 163, 184, 0.14);
      --cinema-notes-disabled-bg: rgba(148, 163, 184, 0.24);
      --cinema-notes-disabled-text: #94a3b8;
      --cinema-notes-primary-action-bg: #e2e8f0;
      --cinema-notes-primary-action-hover-bg: #f8fafc;
      --cinema-notes-primary-action-text: #334155;
      --notes-text-primary: var(--cinema-notes-text-primary);
      --notes-text-secondary: var(--cinema-notes-text-secondary);
      --notes-text-muted: var(--cinema-notes-text-muted);
      --notes-border: var(--cinema-notes-border);
      --notes-editor-placeholder: var(--cinema-notes-editor-placeholder);
      --notes-toolbar-icon: var(--cinema-notes-toolbar-icon);
      --notes-toolbar-icon-hover: var(--cinema-notes-toolbar-icon-hover);
      --notes-toolbar-icon-active-bg: var(
        --cinema-notes-toolbar-icon-active-bg
      );
      --notes-toolbar-icon-filter: invert(0.82) brightness(1.18);
      --notes-toolbar-icon-hover-filter: invert(1) brightness(1.2);
      --notes-toolbar-bg: var(--cinema-notes-toolbar-bg);
      --notes-toolbar-hover-bg: var(--cinema-notes-toolbar-hover-bg);
      --notes-disabled-bg: var(--cinema-notes-disabled-bg);
      --notes-disabled-text: var(--cinema-notes-disabled-text);
      --notes-primary-action-bg: var(--cinema-notes-primary-action-bg);
      --notes-primary-action-hover-bg: var(
        --cinema-notes-primary-action-hover-bg
      );
      --notes-primary-action-text: var(--cinema-notes-primary-action-text);
      --wang-editor-mark-block-bg: #0f172a;
      --wang-editor-mark-block-border: rgba(148, 163, 184, 0.28);
      --wang-editor-mark-chip-bg: rgba(15, 23, 42, 0.82);
      --wang-editor-mark-block-text: #f1f5f9;
      --wang-editor-mark-block-muted-text: #94a3b8;
    }

    ::v-deep .notes-container .comp-container__editor {
      --wang-editor-mark-block-bg: #0f172a;
      --wang-editor-mark-block-border: rgba(148, 163, 184, 0.28);
      --wang-editor-mark-chip-bg: rgba(15, 23, 42, 0.82);
      --wang-editor-mark-block-text: #f1f5f9;
      --wang-editor-mark-block-muted-text: #94a3b8;
      --wang-editor-text: #f1f5f9;
      --wang-editor-placeholder: #64748b;
    }

    ::v-deep .notes-container .w-e-text-container [contenteditable] {
      color: var(--cinema-notes-text-primary) !important;
      caret-color: var(--cinema-notes-text-primary) !important;
    }

    ::v-deep .notes-container .w-e-text-placeholder {
      color: var(--cinema-notes-editor-placeholder) !important;
    }

    ::v-deep .notes-container markblock {
      color: var(--wang-editor-mark-block-text) !important;
    }

    ::v-deep .notes-container markblock .qa-time,
    ::v-deep .notes-container markblock .qa-title {
      color: inherit !important;
      background: var(--wang-editor-mark-chip-bg) !important;
      border-color: var(--wang-editor-mark-block-border) !important;
    }

    ::v-deep .notes-container markblock .qa-time {
      color: var(--wang-editor-mark-block-muted-text) !important;
    }

    ::v-deep .notes-container markblock .qa-time img {
      filter: var(--notes-toolbar-icon-filter);
    }

    ::v-deep .notes-container markblock .qa-time:hover {
      color: var(--notes-toolbar-icon-hover) !important;
      background: var(--notes-toolbar-hover-bg) !important;
      border-color: var(--wang-editor-mark-block-border) !important;
    }

    ::v-deep .notes-container markblock .qa-time:hover::after {
      background-color: var(--wang-editor-mark-chip-bg) !important;
      filter: var(--notes-toolbar-icon-hover-filter);
    }

    ::v-deep .notes-container .w-e-toolbar .w-e-bar-item button {
      color: var(--notes-toolbar-icon) !important;
    }

    ::v-deep .notes-container .w-e-toolbar .w-e-bar-item button svg {
      fill: var(--notes-toolbar-icon) !important;
      stroke: var(--notes-toolbar-icon) !important;
    }

    ::v-deep .notes-container .w-e-toolbar .w-e-bar-item button:hover,
    ::v-deep .notes-container .w-e-toolbar .w-e-bar-item button.active {
      color: var(--notes-toolbar-icon-hover) !important;
    }

    ::v-deep .notes-container .w-e-toolbar .w-e-bar-item button:hover svg,
    ::v-deep .notes-container .w-e-toolbar .w-e-bar-item button.active svg {
      fill: var(--notes-toolbar-icon-hover) !important;
      stroke: var(--notes-toolbar-icon-hover) !important;
    }

    ::v-deep .notes-container .handle-box {
      background: var(--notes-toolbar-bg) !important;
    }

    ::v-deep .notes-container .handle-box .btn:not(.save-btn):not(.disabled) {
      color: var(--notes-toolbar-icon) !important;
    }

    ::v-deep
      .notes-container
      .handle-box
      .btn:not(.save-btn):not(.disabled):hover {
      color: var(--notes-toolbar-icon-hover) !important;
      background: var(--notes-toolbar-hover-bg) !important;
    }

    ::v-deep .notes-container .handle-box .save-btn:not(.disabled) {
      color: var(--notes-primary-action-text) !important;
      background: var(--notes-primary-action-bg) !important;
    }

    ::v-deep .notes-container .handle-box .save-btn:not(.disabled):hover {
      background: var(--notes-primary-action-hover-bg) !important;
    }

    ::v-deep .notes-container .handle-box .btn.disabled,
    ::v-deep .notes-container .handle-box .save-btn.disabled {
      color: var(--notes-disabled-text) !important;
      background: var(--notes-disabled-bg) !important;
    }

    // L5: 侧栏收起动效
    ::v-deep .course-info-area.sidebar-collapsed {
      width: 0 !important;
      min-width: 0 !important;
      opacity: 0;
      padding: 0 !important;
      border: none !important;
      box-shadow: none !important;
      overflow: hidden;
      pointer-events: none;
    }
  }
}
// S4: Tab 切换动画关键帧
@keyframes fadeSlideIn {
  from {
    opacity: 0;
    transform: translateY(6px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

// Cinema Header
.cinema-header {
  --cinema-header-bg: #0f172a;
  --cinema-header-bg-collapsed: #080b12;
  --cinema-header-text: #f1f5f9;
  --cinema-header-muted: #cbd5e1;
  --cinema-header-border: rgba(255, 255, 255, 0.12);
  --cinema-header-control-bg: rgba(255, 255, 255, 0.1);
  --cinema-header-control-hover-bg: rgba(255, 255, 255, 0.18);
  --cinema-header-brand-bg: rgba(0, 200, 157, 0.1);

  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 24px;
  border-bottom: 1px solid var(--cinema-header-border);
  background: var(--cinema-header-bg);
  flex-shrink: 0;
  transition: background 0.3s, border-bottom-color 0.3s;

  &__inner {
    max-width: 1800px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &__left {
    display: flex;
    align-items: center;
    gap: 12px;
    min-width: 0;
  }

  &__divider {
    width: 1px;
    height: 20px;
    background: var(--cinema-header-border);
  }

  &__title {
    font-size: 15px;
    font-weight: 600;
    color: var(--cinema-header-text);
    letter-spacing: 0.025em;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 400px;
    margin: 0;
  }

  &__right {
    display: flex;
    align-items: center;
    gap: 16px;
    flex-shrink: 0;
  }

  &__actions {
    display: flex;
    align-items: center;
    gap: 8px;
  }
}

.cinema-back-btn {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: none;
  background: transparent;
  color: var(--cinema-header-muted);
  font-size: 20px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  &:hover {
    background: var(--cinema-header-control-hover-bg);
    color: var(--cinema-header-text);
  }
}

.cinema-share-wrap {
  display: flex;
  align-items: center;
  ::v-deep .share-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border-radius: 8px;
    background: var(--cinema-header-control-bg);
    border: none;
    cursor: pointer;
    transition: all 0.2s;
    margin: 0;
    padding: 0;
    img {
      width: 18px;
      height: 18px;
      filter: brightness(0) invert(0.85);
    }
    &:hover {
      background: var(--cinema-header-control-hover-bg);
      img {
        filter: brightness(0) invert(1);
      }
    }
  }
}
.cinema-sidebar-toggle {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border-radius: 8px;
  border: none;
  background: transparent;
  color: var(--cinema-header-muted);
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  &:hover {
    background: var(--cinema-header-control-hover-bg);
    color: var(--cinema-header-text);
  }
  &.active {
    color: var(--mg-brand-primary);
    background: var(--cinema-header-brand-bg);
  }
}

.cinema-header__separator {
  width: 1px;
  height: 16px;
  background: var(--cinema-header-border);
  margin: 0 4px;
}

.cinema-header--collapsed {
  background: var(--cinema-header-bg-collapsed);
  border-bottom-color: rgba(255, 255, 255, 0.05);
}

.video-play-page__h5 {
  min-width: unset;
  width: 100%;
  min-height: calc(100vh - #{$h5-footer-height});
  .left-cont-wrap {
    flex: none;
    width: 100%;
  }
  .left-cont-wrap--audio {
    ::v-deep .video-area {
      height: auto !important;
    }

    ::v-deep .video-player-box--audio {
      height: auto !important;
    }

    ::v-deep .video-player-wrap {
      height: auto !important;
    }

    ::v-deep .audio-player {
      height: auto !important;
    }
  }
  .video-play-content {
    min-height: unset;
    .content-wrap {
      width: 100%;
      flex: 1;
      display: flex;
      flex-direction: column;
      padding: 0;
      margin-top: 0;
      // margin-top: 1.6rem;
        .tabs {
          display: flex;
          .tab {
            flex: 1;
            text-align: center;
            padding: 0.4rem 0;
            font-size: 0.4rem;
            color: #333;
            border-bottom: 0.01rem solid #ccc;
          }
        }
      }
  }
  .tabs-box {
    flex: none;
  }
  ::v-deep .course-info-area.h5-course-info {
    flex: none;
    height: auto;
    min-height: 0;
    overflow: visible;
  }

  html.dark & {
    .video-play-content .content-wrap .tabs {
      background: var(--mg-bg-page);

      .tab {
        color: var(--mg-text-secondary);
        border-bottom-color: var(--mg-border-subtle);

        &.active {
          color: var(--mg-text-primary);
        }
      }
    }
  }
}
// 竖屏视频模式
.portrait-mode {
  --tab-bar-h: 1.12rem;

  ::v-deep .video-area {
    height: var(--video-h, 70vh);
    will-change: height;

    &.pv-snapping {
      transition: height 0.3s ease;
    }

    .video-player-box {
      height: 100%;
    }
  }

  ::v-deep .course-info-area.h5-course-info {
    height: calc(100vh - var(--video-h, 70vh) - var(--tab-bar-h, 1.12rem));
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }
}
.video-play-page__electron {
  height: calc(100vh - #{$nav-height});
  .video-play-content {
    min-height: unset;
    max-height: 100%;
    .content-wrap {
      padding: 45px 24px 45px;
      margin-top: 0;
      .tabs {
        display: flex;
      }
    }
  }
}
// 侧栏收起时的浮动展开按钮
.sidebar-expand-btn {
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 14px;
  background: rgba(15, 23, 42, 0.8);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  color: rgba(203, 213, 225, 1);
  font-size: 12px;
  font-weight: 500;
  border-radius: 8px;
  cursor: pointer;
  z-index: 10;
  transition: all 0.2s;
  border: 1px solid var(--mg-border-subtle);
  &:hover {
    background: rgba(15, 23, 42, 0.95);
    color: #00c89d;
  }
  svg {
    flex-shrink: 0;
  }
}
// 响应式
@media (max-width: 1440px) {
  .video-play-page:not(.video-play-page__h5):not(
      .video-play-page__electron
    ):not(.cinema-mode) {
    .video-play-content .content-wrap {
      padding: 40px 40px 54px;
    }
  }
}
@media (max-width: 1200px) {
  .video-play-page:not(.video-play-page__h5):not(
      .video-play-page__electron
    ):not(.cinema-mode) {
    .video-play-content .content-wrap {
      padding: 20px 20px 30px;
    }
  }
}
// Cinema mode 响应式
@media (max-width: 1440px) {
  .video-play-page.cinema-mode {
    ::v-deep .course-info-area {
      width: 350px;
    }
  }
}
@media (max-width: 1200px) {
  .video-play-page.cinema-mode {
    ::v-deep .course-info-area {
      width: 300px;
    }
    .cinema-header__title {
      max-width: 250px;
    }
  }
}
// 响应式批次 1：≤1024px 布局切换（竖向堆叠）
@media (max-width: 1024px) {
  .video-play-page.cinema-mode {
    .cinema-header {
      padding: 0 16px;
    }
    .cinema-sidebar-toggle span {
      display: none;
    }
    .video-play-content .content-wrap {
      flex-direction: column;
      overflow-y: auto;
    }
    .left-cont-wrap {
      border-radius: 0 !important;
      border: none !important;
      box-shadow: none !important;
      flex: none !important;
      width: 100% !important;
      aspect-ratio: 16 / 9;
      &--audio {
        aspect-ratio: auto;
      }
    }
    ::v-deep .course-info-area {
      width: 100% !important;
      min-width: unset !important;
      border-radius: 0 !important;
      flex: 1;
      min-height: 300px;
    }
  }
}
</style>
